import { processDurationMetrics } from '@/lib/metrics'
import { SectionHeader } from './SectionHeader'
import { TransposedDataGrid } from './TransposedDataGrid'
import type { DurationMetricsItem } from '@/entities/dailyMetric'

interface DurationsTableProps {
  durationMetrics: DurationMetricsItem[]
}

export function DurationsTable({ durationMetrics }: DurationsTableProps) {
  const { rows, dates } = processDurationMetrics(durationMetrics)

  // Filter out zero values
  const processedRows = rows.map((row) => {
    const newRow = { ...row }
    dates.forEach((date: string) => {
      const value = parseFloat((newRow[date] as string) || '0')
      if (value === 0) {
        newRow[date] = ''
      }
    })
    return newRow
  })

  return (
    <div className="flex flex-col w-full mt-8">
      <SectionHeader title="Duration Metrics (%)" />
      <div className="bg-white rounded-lg shadow-sm border border overflow-hidden">
        <TransposedDataGrid
          rows={processedRows}
          firstColumn={{
            field: 'metric',
            headerName: 'Duration',
          }}
          dates={dates}
        />
      </div>
    </div>
  )
}